import React from 'react';
import PropTypes from 'prop-types';
import Section from 'components/common/Section';
import { Row, Col, Image } from 'react-bootstrap';
import { getEffectiveUrl } from 'y4/Falcon';
import is from 'is_js';

const Partner = ({ url, src, height }) => (
  <Col xs={3} sm="auto" className="my-1 my-sm-3 px-x1">
    <a href={url}>
      <Image
        className="landing-cta-img"
        src={src}
        height={height}
        alt="Partner"
      />
    </a>
  </Col>
);

const Partners = ({ configs }) => {
  return is.empty(configs) ? null : (
    <Section bg="light" className="py-3 shadow-sm">
      <Row className="flex-center">
        {configs
          .map(config => {
            return {
              src: getEffectiveUrl(config.imageUrl),
              height: config.content,
              url: getEffectiveUrl(config.url)
            };
          })
          .map((partner, index) => (
            <Partner key={index} {...partner} />
          ))}
      </Row>
    </Section>
  );
};

Partner.propTypes = {
  url: PropTypes.string,
  src: PropTypes.string,
  height: PropTypes.string
};

Partners.propTypes = {
  configs: PropTypes.array
};

export default Partners;
